/**
 * Centralised friendly labels for the three internal `user.role` values.
 *
 * Backend roles:
 *   - `super_admin`       → "Platform Administrator"
 *   - `club_admin`        → "Club Administrator"   (the shared-passcode shell)
 *   - `golf_shop_staff`   → "Club Staff"           (named per-club staff)
 *   - `member`            → "Member"
 *
 * `roleTitle(user)` returns the user's specific job title (e.g. "Buyer",
 * "Head Pro") if they're staff and have one set. Falls back to the friendly
 * role label so the "Role" field is never empty.
 */
export function roleLabel(user) {
  if (!user) return "";
  const r = user.role || "member";
  if (r === "super_admin") return "Platform Administrator";
  if (r === "club_admin") return "Club Administrator";
  if (r === "golf_shop_staff") return "Club Staff";
  return "Member";
}

export function roleTitle(user) {
  if (!user) return "";
  if (user.role === "golf_shop_staff") {
    const t = (user.title || "").trim();
    if (t) return t;
    return "Club Staff";
  }
  if (user.role === "club_admin") return "Club Administrator";
  if (user.role === "super_admin") return "Platform Administrator";
  return "Member";
}
